module.exports = __webpack_public_path__ + "img/shipping_mobile.369b269f.png";